export default __webpack_public_path__ + "static/media/icon-hooks.629fba25.png";